import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ef02ae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TPainelDeEstatisticas",
  "data-testid": "TPainelDeEstatisticas"
}
const _hoisted_2 = { class: "TPainelDeEstatisticas__Cabecalho" }
const _hoisted_3 = { class: "TPainelDeEstatisticas__CabecalhoEsquerda" }
const _hoisted_4 = { class: "TPainelDeEstatisticas__CabecalhoSeletoresProjeto" }
const _hoisted_5 = { class: "TPainelDeEstatisticas__CaixaDoSeletor" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-folder" }, null, -1))
const _hoisted_7 = { class: "TPainelDeEstatisticas__CaixaDoSeletor" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-map" }, null, -1))
const _hoisted_9 = { class: "TPainelDeEstatisticas__Quadro" }

import { MenuItem } from "primevue/menuitem"
  import {
    MDropdown,
    MMultiSelect,
    OTrilhaDeNavegacao,
  } from "@/components/Gerais"
  import OCabecalhoPeriodoEntreDatas from "@/components/Gerais/OCabecalhoPeriodoEntreDatas/OCabecalhoPeriodoEntreDatas.vue"
  import { computed, onBeforeMount, ref } from "vue"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import MAtividadesComOcorrencia from "@/components/Estatisticas/MAtividadesComOcorrencia/MAtividadesComOcorrencia.vue"
  import MGraficoAtividadesPorPeriodo from "@/components/Estatisticas/MGraficoAtividadesPorPeriodo/MGraficoAtividadesPorPeriodo.vue"
  import { AtividadesParams } from "@/repositorios/atividades/atividades.modelos"
  import { usarListarEstatisticasStore } from "@/store/estatisticas/ListarEstatisticas/ListarEstatisticas.store"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"
  import GruposDeProjetosRepositorio from "@/repositorios/gruposDeProjetos/gruposDeProjetos.repositorio"
  import {
    ListarGruposDeProjetosSimples,
    ParametrosGruposDeProjetos,
  } from "@/repositorios/gruposDeProjetos/gruposDeProjetos.modelo"
  import { EntidadeSimples } from "@/types/gerais"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarBuscarMaisDados } from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import {
    ParamsProjeto,
    ProjetosSimples,
  } from "@/repositorios/projeto/projeto.modelo"
  import { storeToRefs } from "pinia"
  import { usarDebounces } from "@/composable/UsarDebounces/usarDebounces"
  import { cancelamento } from "@/http/cancelar/cancelar.services"
  import { useI18n } from "vue-i18n"

  interface Props {
    breadCrumbItems: MenuItem[]
    home: MenuItem
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TPainelDeEstatisticas',
  props: {
    breadCrumbItems: null,
    home: null
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const projetosRepositorio = new ProjetoRepositorio()
  const gruposDeProjetosRepositorio = new GruposDeProjetosRepositorio()

  const { verEventosPlanejados, verTodasAsAtividades } =
    usarListarEstatisticasStore()
  const { carregandoAtividades, carregandoEventos } = storeToRefs(
    usarListarEstatisticasStore()
  )
  const { pegarSomenteData, adicionarUmDia, subtrairUmDia } = usarDataHora()
  const { leitor, resolverLeitor } = usarLeitorDeDados()
  const { onErro } = usarMensagemUsuario()
  const { colher } = usarManipuladorObjetos()
  const { debounce } = usarDebounces()
  const { buscarMaisDados, reinserirDadoPreSelecionadoNaLista } =
    usarBuscarMaisDados()

  const leitorDeGruposDeProjetos = leitor<
    ListarGruposDeProjetosSimples,
    ParametrosGruposDeProjetos
  >(gruposDeProjetosRepositorio.listarGruposDeProjetos, {
    "por-pagina": "30",
    "ordenar-por": "asc.nome",
    ativo: "igual.true",
  })
  const leitorDeProjetos = leitor<ProjetosSimples, ParamsProjeto>(
    projetosRepositorio.listarProjetos,
    {
      "ordenar-por": ["asc.nome_projeto"],
      "por-pagina": 1000,
      ativo: "igual.true",
    }
  )

  const datasPeriodo = ref<Date[]>([])
  const gruposDeProjetos = ref<EntidadeSimples[]>([])
  const projetos = ref<EntidadeSimples[]>([])
  const projetosSelecionados = ref<string[]>([])
  const grupoDeProjetoSelecionado = ref<string>()
  const estaMontandoComponente = ref(false)
  const opcaoDeTodosOsProjetos = {
    nome: t("todosOsProjetos"),
    id: "todos-projetos",
  }

  const dataInicial = computed(() => {
    return datasPeriodo.value[0]
  })

  const dataFinal = computed(() => {
    return datasPeriodo.value[1]
  })

  const estaCarregandoEstatisticas = computed(
    () =>
      estaMontandoComponente.value ||
      carregandoAtividades.value ||
      carregandoEventos.value
  )

  const estaCarregandoGruposDeProjetos = computed(
    () => leitorDeGruposDeProjetos.resultado.status === "pendente"
  )

  const estaCarregandoProjetos = computed(
    () => leitorDeProjetos.resultado.status === "pendente"
  )

  const popularFiltros = async (): Promise<void> => {
    await Promise.allSettled([buscarGrupos(), buscarProjetos()])
  }

  const buscarGrupos = async (): Promise<void> => {
    await leitorDeGruposDeProjetos.executar()

    resolverLeitor(leitorDeGruposDeProjetos.resultado, {
      sucesso(resultado) {
        gruposDeProjetos.value = [
          opcaoDeTodosOsProjetos,
          ...colher<ListarGruposDeProjetosSimples, EntidadeSimples>(resultado, [
            "id",
            "nome",
          ]),
        ]
        grupoDeProjetoSelecionado.value = opcaoDeTodosOsProjetos.id
      },
      erro(erro) {
        onErro({
          resumo: t("erroAoBuscarGruposDeProjetos"),
          detalhes: erro.mensagem,
        })
      },
    })
  }

  const buscarMaisGrupos = async (): Promise<void> => {
    await buscarMaisDados(leitorDeGruposDeProjetos, gruposDeProjetos)
    reinserirDadoPreSelecionadoNaLista(gruposDeProjetos, opcaoDeTodosOsProjetos)
  }

  const buscarProjetos = async (idGrupoDeProjetos?: string): Promise<void> => {
    cancelamento.cancelarRequisicoesPendentes()

    if (idGrupoDeProjetos !== opcaoDeTodosOsProjetos.id && idGrupoDeProjetos) {
      leitorDeProjetos.incrementarParametros({
        grupo_de_projetos: `igual.${idGrupoDeProjetos}`,
      })
    } else {
      const parametros = leitorDeProjetos.obterParametros()
      leitorDeProjetos.resetarParametrosParaEstadoInicial()
      delete parametros.grupo_de_projetos
      leitorDeProjetos.sobrescreverParametros(parametros)
    }

    await leitorDeProjetos.executar()

    const selecionarTodosProjetos = (
      projetosRequisitados: EntidadeSimples[]
    ): void => {
      projetosSelecionados.value = projetosRequisitados.map(
        (projeto) => projeto.id
      )
    }

    if (leitorDeProjetos.resultado.status === "cancelado") {
      throw new Error(t("requisicaoCancelada"))
    }

    resolverLeitor(leitorDeProjetos.resultado, {
      sucesso(resultado) {
        projetos.value = colher(
          resultado,
          ["id", "nomeProjeto"],
          ["id", "nome"]
        )
        selecionarTodosProjetos(projetos.value)
      },
      erro(erro) {
        onErro({
          resumo: t("erroAoBuscarProjetos"),
          detalhes: erro.mensagem,
        })
      },
    })
  }

  const buscarDadosDeAtividadesEventos = async (): Promise<void> => {
    if (!dataInicial.value || !dataFinal.value) {
      return
    }
    cancelamento.cancelarRequisicoesPendentes()

    const dataInicioFormatada = pegarSomenteData(
      subtrairUmDia(dataInicial.value)
    )
    const dataFimFormatada = pegarSomenteData(
      adicionarUmDia(dataFinal.value)
    )

    const parametros: AtividadesParams = {
      "por-pagina": "1000",
      data_inicio: `entre.(${dataInicioFormatada},${dataFimFormatada})`,
      id_projeto: projetosSelecionados.value.length
        ? `em.(${projetosSelecionados.value.join(",")})`
        : undefined,
    }

    Promise.all([
      verTodasAsAtividades(parametros),
      verEventosPlanejados(parametros),
    ]).catch((erro) => {
      estaMontandoComponente.value = false
      onErro({
        detalhes: erro.message,
        resumo: t("ocorreuUmErroAoBuscarAsInformacoes"),
      })
    })
  }

  const buscarProjetosEAtualizarGraficos = async (
    idGrupoDeProjetos: string
  ): Promise<void> => {
    try {
      await buscarProjetos(idGrupoDeProjetos)

      atualizarGraficos(null)
    } catch (erro) {} // eslint-disable-line no-empty
  }

  const atualizarGraficos = debounce(async (): Promise<void> => {
    if (estaMontandoComponente.value) {
      return
    }
    await buscarDadosDeAtividadesEventos()
  }, 500)

  const inicializarEstatisticas = async (): Promise<void> => {
    estaMontandoComponente.value = true
    await popularFiltros()
    await buscarDadosDeAtividadesEventos()
    estaMontandoComponente.value = false
  }

  onBeforeMount(() => inicializarEstatisticas())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(OTrilhaDeNavegacao), {
          class: "TPainelDeEstatisticas__CabecalhoEsquerdaBreadCrumb",
          "inicio-da-trilha": __props.home,
          "itens-da-trilha": __props.breadCrumbItems
        }, null, 8, ["inicio-da-trilha", "itens-da-trilha"]),
        _createVNode(OCabecalhoPeriodoEntreDatas, {
          datasPeriodo: datasPeriodo.value,
          "onUpdate:datasPeriodo": [
            _cache[0] || (_cache[0] = ($event: any) => ((datasPeriodo).value = $event)),
            _unref(atualizarGraficos)
          ],
          "mostrar-botoes-anterior-e-proximo": true
        }, null, 8, ["datasPeriodo", "onUpdate:datasPeriodo"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_unref(MDropdown), {
            modelValue: grupoDeProjetoSelecionado.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((grupoDeProjetoSelecionado).value = $event)),
              buscarProjetosEAtualizarGraficos
            ],
            "buscar-mais-itens": buscarMaisGrupos,
            carregando: _unref(estaCarregandoGruposDeProjetos),
            class: "TPainelDeEstatisticas__SeletorGrupos",
            "data-testid": "TPainelDeEstatisticas__SeletorGrupos",
            "option-label": "nome",
            "option-value": "id",
            options: gruposDeProjetos.value,
            placeholder: _unref(t)('gruposDeProjetos'),
            "usar-carregamento-sob-demanda": "",
            width: "544px"
          }, null, 8, ["modelValue", "carregando", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(MMultiSelect), {
            modelValue: projetosSelecionados.value,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((projetosSelecionados).value = $event)),
              _unref(atualizarGraficos)
            ],
            carregando: _unref(estaCarregandoProjetos),
            class: "TPainelDeEstatisticas__SeletorProjetos",
            "data-testid": "TPainelDeEstatisticas__SeletorProjetos",
            "exibicao-de-opcoes": "comma",
            "legenda-maximo-selecionados": `{0} ${_unref(t)('projetosSelecionados')}`,
            "maximo-de-legendas-selecionadas": 1,
            nome: "projetos",
            "option-label": "nome",
            "option-value": "id",
            options: projetos.value,
            placeholder: _unref(t)('projetos'),
            width: "544px"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "carregando", "legenda-maximo-selecionados", "options", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(MAtividadesComOcorrencia, { "esta-carregando": _unref(estaCarregandoEstatisticas) }, null, 8, ["esta-carregando"]),
      _createVNode(MGraficoAtividadesPorPeriodo, {
        "data-final": _unref(dataFinal),
        "data-inicial": _unref(dataInicial),
        "esta-carregando": _unref(estaCarregandoEstatisticas)
      }, null, 8, ["data-final", "data-inicial", "esta-carregando"])
    ])
  ]))
}
}

})